import React, { useEffect } from 'react'

import { Box, Button, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ReactComponent as Logo } from '../../assets/icompleat.svg'
import styles from './AuthenticationFailedStyles'

const useStyles = makeStyles(styles)

const AuthenticationFailed = props => {
  const classes = useStyles()
  useEffect(() => {
    document.title = 'Authentication failed'
  }, [])

  return (
    <Paper className={classes.paper} elevation={0}>
      <Box className={classes.header}>
        <Logo />
        <Typography component="h2" variant="h4" className={classes.headline}>
          We could not authenticate you, please try again!
        </Typography>
        <Typography component="p" className={classes.paragraph}>
          Please go to one of the following
        </Typography>
        <Box className={classes.buttonContainer}>
          <Button variant="contained" href="/login" color="primary" className={classes.button}>
            Login
          </Button>
          or
          <Button variant="contained" href="/register" color="primary" className={classes.button}>
            Register
          </Button>
        </Box>
      </Box>
    </Paper>
  )
}

export default AuthenticationFailed
